"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomColor = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_common_components_1 = require("@desygner/ui-common-components");
const ui_common_translation_1 = require("@desygner/ui-common-translation");
const CustomColor_styles_1 = require("./CustomColor.styles");
function CustomColor({ initialColor = 'black', titleKey, variant = 'stroke', bulletVariant = 'circle', bulletSize = 'Medium', onUpdate, }) {
    const [selectedColor, setSelectedColor] = (0, react_1.useState)(initialColor);
    (0, react_1.useEffect)(function updateColorWhenPropChange() {
        setSelectedColor(initialColor);
    }, [initialColor]);
    const { t } = (0, ui_common_translation_1.useTranslation)();
    const title = t(titleKey);
    const handleColorChange = (0, react_1.useCallback)((color) => {
        setSelectedColor(color);
        onUpdate(color);
    }, [onUpdate]);
    return ((0, jsx_runtime_1.jsx)(CustomColor_styles_1.StyledCustomColorContainer, { children: (0, jsx_runtime_1.jsxs)(ui_common_components_1.Tooltip, { text: `${title}: ${selectedColor.toLocaleUpperCase()}`, position: "bottom", visible: !!title, children: [variant === 'fill' && ((0, jsx_runtime_1.jsx)(ui_common_components_1.ColorBullet, { color: selectedColor, onChange: (color) => handleColorChange(color), size: bulletSize, variant: bulletVariant })), variant === 'stroke' && ((0, jsx_runtime_1.jsx)(CustomColor_styles_1.StyledCustomColor, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.ColorBullet, { color: selectedColor, onChange: (color) => handleColorChange(color), size: bulletSize, variant: bulletVariant }) }))] }) }));
}
exports.CustomColor = CustomColor;
//# sourceMappingURL=CustomColor.js.map